import { useState } from 'react';
import { Box, Typography, Button, Grid } from '@mui/material';
import PlayerCard from '../pages/players/get/components/PlayerCard.js';
import { mergePlayers, premergePlayers } from '../../api/index.js';
import { useLocation, useNavigate } from 'react-router-dom';
import DsasButton from '../components/DsasButton/DsasButton.js';
////////  ICONS /////////
import { faUserGroup, faBackward, faMagnifyingGlass, faCheck } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import useStyles from '../../styles/global-mui.js'

const useFusionMode = (players) => {

  const navigate = useNavigate()
  const classes = useStyles();
  const location = useLocation();


  const [isFusionMode, setIsFusionMode] = useState(false);
  const [leftZone, setLeftZone] = useState([]);
  const [rightZone, setRightZone] = useState([]);

  const toggleFusionMode = () => {
    setIsFusionMode((prev) => !prev);
  };

  const addPlayerToZone = (player, zone) => {
    if (zone === 'left') {
      if(!leftZone.length)
        setLeftZone((prev) => [...prev, player]);
    } else if (zone === 'right') {
      if(!rightZone.find(p => p._id === player.id))
        setRightZone((prev) => [...prev, player]);
    }
  };

  const removePlayerFromZone = (playerId, zone) => {
    if (zone === 'left') {
      setLeftZone((prev) => prev.filter((player) => player._id !== playerId));
    } else if (zone === 'right') {
      setRightZone((prev) => prev.filter((player) => player._id !== playerId));
    }
  };

  const submit = async () => {
    const mergedResponse = await premergePlayers(leftZone[0]._id, rightZone.map(p => p._id))

    if(mergedResponse.status === 200){
      const {mergedPlayer, idsToDelete, matchesUpdated, gamefactsUpdated} = mergedResponse.data
      navigate('/sports/players/merge', { state: { mergedPlayer, idsToDelete, matchesUpdated, gamefactsUpdated, returnTo: `/sports/players${location.search}` } });
    }
    
  }

  const actions = isFusionMode
    ? [
        {
          label: 'Joueur à conserver',
          onClick: (player) => addPlayerToZone(player, 'left'),
        },
        {
          label: 'Joueur à supprimer',
          onClick: (player) => addPlayerToZone(player, 'right'),
        },
      ]
    : [];

  const FusionZones = () =>
    isFusionMode && (
    
      <Box
        className='medium-padding'
      >
         <Grid container spacing={1.5} alignItems="stretch">
         <Grid item xs={5.75} sm={5.75} md={5.75} lg={5.75}
          sx={{ display: 'flex', flexDirection: 'column' }}
          >
          <Box className='display-grid small-padding'>
            <h3 className='cardtitle'>Joueur à conserver</h3>
          </Box>
          <Box
             sx={{
              flex: 1,
              height: '100%',
              minHeight: 200,
              border: '1px solid #ccc',
              borderRadius: '8px',
              padding: 2,
              overflowY: 'auto',
            }}
          >
            {leftZone.map((player) => (
              <Box className='display-grid'>
               
                <Box className='medium-padding' sx={{justifySelf: 'center', minWidth: '50%'}}>
                    <PlayerCard
                      key={player._id}
                      player={player}
                      showExport={false}
                      showPicture={false}
                      className={classes.customCard}
                      actions={[
                        {
                          label: 'Retirer',
                          onClick: () => removePlayerFromZone(player._id, 'left'),
                        },
                      ]}
                    />
               </Box>
              </Box>
            ))}
          </Box>
        </Grid>
        <Grid item xs={0.5} sm={0.5} md={0.5} lg={0.5}
          sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        >
          <FontAwesomeIcon icon={faBackward} size="2x" style={{ color: '#ccc', 'padding-top':'5rem' }} />
        </Grid>
        <Grid item xs={5.75} sm={5.75} md={5.75} lg={5.75}
              sx={{ display: 'flex', flexDirection: 'column' }}
            >
              <Box className='display-grid small-padding'>
                <h3 className='cardtitle'>{rightZone.length} Joueur(s) à supprimer</h3>
              </Box>

              <Box
                sx={{
                  flex: 1,
                  height: '100%',
                  minHeight: 200,
                  border: '1px solid #ccc',
                  borderRadius: '8px',
                  padding: 2,
                  overflowX: 'auto',
                  display: 'flex',
                  flexDirection: 'row',
                  gap: 1,
                  justifyContent: rightZone.length ? 'space-around' : 'center',
                  alignItems: rightZone.length ? 'stretch' : 'center',
                  opacity: leftZone.length > 0 ? 1 : 0.7, // optionnel: “désactivé”
                }}
              >
                {leftZone.length > 0 ? (
                  rightZone.map((player) => (
                    <Box key={player._id} className='medium-padding' sx={{ minWidth: '50%' }}>
                      <PlayerCard
                        player={player}
                        showExport={false}
                        showPicture={false}
                        className={classes.customCard}
                        actions={[{ label: 'Retirer', onClick: () => removePlayerFromZone(player._id, 'right') }]}
                      />
                    </Box>
                  ))
                ) : (
                  <Typography variant="body2" color="text.secondary" fontStyle="italic">
                    Sélectionnez d’abord un joueur à conserver
                  </Typography>
                )}
              </Box>
            </Grid>
        </Grid>
      <Box className='small-padding' ></Box>
      <Box className='centered-wrapper small-padding'>
        <DsasButton disabled={leftZone.length !== 1  || !rightZone.length} label={'Valider la fusion'} icon={faCheck} onClick={submit} variant = 'alternative' />
      </Box>
      <Box className='small-padding display-grid'>
        {leftZone.length !== 1 && <Typography sx={{justifySelf: 'center'}} variant="body2" color="text.secondary">Veuillez sélectionner un joueur à conserver</Typography>}
        {rightZone.length === 0 && <Typography sx={{justifySelf: 'center'}} variant="body2" color="text.secondary">Veuillez sélectionner au moins un joueur à supprimer</Typography>}    
        {rightZone.length > 1 && <Typography sx={{justifySelf: 'center'}} variant="body2" color="text.secondary">Vous avez sélectionné {rightZone.length} joueurs à supprimer</Typography>}
        {leftZone.length === 1 && rightZone.length > 0 && (
          <Typography sx={{justifySelf: 'center'}} variant="body2" color="text.secondary">
            {`Fusionner “le(s) joueur(s) à supprimer” avec le “Joueur à conserver”`}
          </Typography>
        )}
        </Box>
      </Box>
    );

  const FusionToggle = () => (
     <DsasButton label={isFusionMode ? 'Retour au Mode Recherche' : 'Passer en Mode Fusion'} icon={isFusionMode ? faMagnifyingGlass : faUserGroup} onClick={toggleFusionMode} variant = 'secondary' />
  );

  return {
    isFusionMode,
    FusionToggle,
    FusionZones,
    actions,
  };
};

export default useFusionMode;
